// extracted by mini-css-extract-plugin
module.exports = {"appBar":"styles_appBar__1vej-","toolBar":"styles_toolBar__1wXOF","tab":"styles_tab__YKsX7","tabSelected":"styles_tabSelected__3nHp3","menuIcon":"styles_menuIcon__2O3W-"};